import { ComponentType, ReactNode } from 'react';
import { TagProps } from '../components/Tag';
import { IconProps } from 'foundations-assets/icons/icon.types';
import { BadgeProps } from '../components/Badge';
import { CallbackProps } from '../../types';

export type SingleValue = string | number | boolean;

export interface Option extends CallbackProps {
  avatar?: ReactNode;
  badge?: ReactNode | { text: string; use: BadgeProps['use'] };
  buttonText?: ReactNode;
  'data-test-id'?: string;
  disabled?: boolean;
  dropdownText?: ReactNode;
  groupIdx?: number;
  help?: ReactNode;
  /**
   * Changed from accepting string to an icon from foundations-assets
   */
  icon?: ComponentType<IconProps>;
  iconColor?: IconProps['color'];
  imageUrl?: string;
  loading?: boolean;
  tag?: { text: string; use: TagProps['use'] };
  tagUse?: TagProps['use'];
  text?: string;
  title?: string;
  value?: SingleValue;
  /**
   * If an option needs to be validated or confirmed after selection, use the
   * `loading: true` and `clearableValue: false` on the option object.
   */
  clearableValue?: boolean;
  getCheckboxState?: (option: Option) => {
    indeterminate: boolean;
    checked: boolean;
  };
}

export type OptionGroup = Option & {
  dropdownText?: ReactNode;
  emptyMessage?: string;
  options: Options;
  selectAll?: boolean;
  text?: string;
  title?: string;
};

export type OptionOrGroup = Option | OptionGroup;

export type Options = OptionOrGroup[];

export function isOptionGroup(option: OptionOrGroup): option is OptionGroup {
  return (option as OptionGroup).options !== undefined;
}
